'use client';

import { getDepartmentIdFromIdent, IVehicleConfiguration, getLocationIDByMake } from 'next-common';
import { mapEmployeeToUser } from '@utils/sales/employee';
import { useAppSelector } from '@store/hooks';
import { IVehicleListOrderProps } from '@common/interfaces/vehicle-page';
import { selectCustomerType, selectDealerId, selectEmployee } from '@store/selectors';
import { getOrderId } from '@utils/app/pageProps';

export const useUpdateOrderVariablesFromSelectedVehicle = () => {
  const customerType = useAppSelector(selectCustomerType);
  const employee = useAppSelector(selectEmployee);
  const selectedDealer = useAppSelector(selectDealerId);

  const getOrderVariables = (vehicle: IVehicleConfiguration): IVehicleListOrderProps => {
    return {
      id: getOrderId(),
      input: {
        customer: { customerType },
        orderReference: { pimId: vehicle?.id, pimCode: vehicle?.sku },
        soldByDealerId:
          vehicle?.model?.isAgent && vehicle?.model?.make
            ? getLocationIDByMake(vehicle?.model?.make)
            : (selectedDealer ?? getDepartmentIdFromIdent(employee?.employeeId)),
        isAgent: vehicle?.model?.isAgent,
        user: employee ? mapEmployeeToUser(employee, selectedDealer) : null,
        ...(vehicle?.model?.series
          ? { lead: { modelSeries: vehicle?.model?.series, make: vehicle?.model?.make } }
          : {}),
        discount: 0,
      },
    };
  };

  return getOrderVariables;
};
